import { franc } from 'franc';

const SUPPORTED_LANGUAGES = ['nld', 'eng'] as const;

export function detectLanguage(text: string = ''): 'nl' | 'en' {
  // First try to get browser language
  const browserLang = getBrowserLanguage();
  if (text.length < 10) return browserLang;
  
  // If there's enough text, detect the language
  const detectedLang = franc(text, {
    only: Array.from(SUPPORTED_LANGUAGES),
    minLength: 1
  });
  
  return detectedLang === 'nld' ? 'nl' : 'en';
}

export function getBrowserLanguage(): 'nl' | 'en' {
  const lang = navigator.language.toLowerCase();
  return lang.startsWith('nl') ? 'nl' : 'en';
}

// Greetings for each agent in both languages
export const greetings = {
  julia: {
    nl: "Hallo! Ik ben Julia van Eye Catching Media klantenservice. Hoe kan ik u vandaag helpen?",
    en: "Hi! I'm Julia from Eye Catching Media customer support. How can I help you today?"
  },
  tom: {
    nl: "Goedendag! Ik ben Tom van Eye Catching Media klantenservice. Waarmee kan ik u helpen?",
    en: "Hello! I'm Tom from Eye Catching Media customer support. How may I assist you today?"
  },
  petra: {
    nl: "Welkom! Ik ben Petra van Eye Catching Media klantenservice. Waar kan ik u mee van dienst zijn?",
    en: "Welcome! I'm Petra from Eye Catching Media customer support. How can I be of service today?"
  }
};

export function getRandomGreeting(language: 'nl' | 'en', agentId?: string): string {
  // If agent ID is provided, use that specific greeting
  if (agentId && greetings[agentId as keyof typeof greetings]) {
    return greetings[agentId as keyof typeof greetings][language];
  }
  
  // Fallback to Julia's greeting if agent ID is not provided or invalid
  return greetings.julia[language];
}